import { render, staticRenderFns } from "./Charts.vue?vue&type=template&id=541befb8&scoped=true&"
import script from "./Charts.ts?vue&type=script&lang=ts&"
export * from "./Charts.ts?vue&type=script&lang=ts&"
import style0 from "./Charts.scss?vue&type=style&index=0&id=541befb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541befb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
